// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3NQGE","topBottomGutter":"Layout_topBottomGutter__1Ka-D"};